
import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import { AuthModal } from './AuthModal';
import { useLocation } from 'react-router-dom';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen font-sans text-gfa-inkBlack bg-gfa-warmWhite selection:bg-gfa-gold/20 selection:text-gfa-inkBlack">
      <Navbar />
      <AuthModal />
      <main className="flex-grow pt-[80px] md:pt-[90px]">
        {children}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Layout;

